import {GET_FAQ} from "./action_type";
import {SET_FAQ,SET_LOADING} from "./mutation_types";
import {getApi} from "../../data/ApiService";
import {SET_ERROR} from "../eventManagement/mutation_types";


export default {
    async [GET_FAQ]({commit}) {
        commit(SET_LOADING, true);
        try {
            const response = await getApi('topics/17/page/1/count/100');
            commit(SET_FAQ, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    }

}